import { useNavigate } from 'react-router-dom'
import type { NotificationItemProps } from 'global/types/props'
import Icon from 'shared/components/icon'
import { formatTime } from 'shared/services/utils'
import { useUpdateIsReadNotificationMutation } from 'store/notifications'

export const NotificationItem = ({ notification }: NotificationItemProps) => {
  const navigate = useNavigate()
  const [updateIsRead] = useUpdateIsReadNotificationMutation()

  const handleClick = () => {
    updateIsRead(notification.pkId)
    navigate(`/notifications/${notification.pkId}`, { preventScrollReset: true })
  }

  return (
    <button
      className='border-b bg-white w-full text-left hover:bg-gray-50 transition-colors'
      onClick={handleClick}
    >
      <div className='flex flex-row items-center p-3'>
        <div className='flex-1 min-w-0'>
          <div className='flex flex-row items-start justify-between mb-1'>
            <h3
              className={`${notification.isRead ? 'text-black' : 'text-primary'} font-medium text-sm line-clamp-2`}
            >
              {notification.title}
            </h3>
          </div>

          <p
            className={`${notification.isRead ? 'text-neutral' : 'text-primary'} text-sm line-clamp-2 mb-2`}
          >
            {notification.subtitle || notification.body?.slice(0, 100) + '...'}
          </p>

          <div className='text-xs text-light-neutral'>
            {formatTime(notification.notificationDate)}
          </div>
        </div>
        <div className='flex-shrink-0 ml-3'>
          <Icon icon='chevron-right' size={16} className='text-neutral' />
        </div>
      </div>
    </button>
  )
}
